import { PropsWithChildren } from 'react';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';
import { MotionSecondaryHeaderLogoWrapper } from '../MotionSecondaryHeaderLogoWrapper/MotionSecondaryHeaderLogoWrapper';

interface MotionAboutUsHeaderLogoProps extends PropsWithChildren {
  className?: string;
}

export const MotionAboutUsHeaderLogo = ({
  className,
  children,
  ...props
}: MotionAboutUsHeaderLogoProps) => {
  return (
    <MotionSecondaryHeaderLogoWrapper
      {...props}
      className={className}
      initial={{
        opacity: 0,
        scale: 0,
      }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: ANIMATION_CONFIG.aboutUsHeader.logo.duration,
        delay: ANIMATION_CONFIG.aboutUsHeader.logo.delay,
        type: 'spring',
      }}
    >
      {children}
    </MotionSecondaryHeaderLogoWrapper>
  );
};

